import InventoryBrandParts from "./inventory-brand-parts";
import { getBrandBySlug } from "./inventory-page-data";

export function createInventoryBrandPage(enSlug) {
	return function InventoryBrandPage({ db }) {
		const brand = getBrandBySlug("en", enSlug);
		if (!brand) return null;
		return (
			<InventoryBrandParts
				locale="en"
				slug={enSlug}
				db={db}
				pageSize={brand.pageSize}
			/>
		);
	};
}
